import Router from 'vue-router';
import Vue from 'vue';
import routers from './router';
import config from '../../config';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  // base: 'bm',
  base: config.publicPath,
  routes: routers
});

/**
 * router认证
 */
import sxwAuth from '../router/auth';
router.beforeEach((to, from, next) => {
  sxwAuth.router(to, from, next);
});

export default router;
